import React, { useState } from "react";
import toast from "react-hot-toast";
import Header from "../components/Header";
import { CSF_CONTACT } from "../constants/company";
import Footer from "../components/Footer";
import { useAuth } from "../context/auth";
import contactService from "../api/services/contact.service";

const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function ContactForm() {
  const { user } = useAuth();
  // Most messages come from the account holder: start from their details
  const [form, setForm] = useState({
    first_name: user?.first_name || "",
    last_name: user?.last_name || "",
    email: user?.email || "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const field = (name) => ({
    value: form[name],
    onChange: (e) => setForm((f) => ({ ...f, [name]: e.target.value })),
  });

  const send = async () => {
    const data = Object.fromEntries(
      Object.entries(form).map(([k, v]) => [k, v.trim()]),
    );
    if (!data.first_name) return toast.error("Please enter your first name.");
    if (!EMAIL_PATTERN.test(data.email)) {
      return toast.error("Please enter a valid e-mail address so we can reply.");
    }
    if (!data.message) return toast.error("Please enter your message.");

    setSending(true);
    try {
      await contactService.send(data);
      setForm((f) => ({ ...f, message: "" }));
      toast.success("Thanks, your message has been sent. We'll reply by e-mail.");
    } catch (e) {
      toast.error(
        `Your message could not be sent. Please try again, or e-mail us at ${CSF_CONTACT.email}.`,
      );
    } finally {
      setSending(false);
    }
  };

  return (
    // <div className="min-h-screen bg-gradient-to-b from-[#f3f6fb] via-[#dee5f2] to-[#c7d3e7] flex flex-col items-center justify-between px-4">
    <div className="min-h-full flex flex-col justify-between bg-page-gradient">
  
  <Header/>
      {/* PAGE HEADER */}
      <main className="w-full px-5 sm:px-0 my-4 ">
      <h2 className="font-kollektif text-fluid-2xl font-normal text-[#173151] text-center">Get in touch</h2>
      <p className="text-[#0A0A0A] font-manrope text-center mt-2">
        Have a question? We'd love to hear from you.
      </p>

      {/* Form Card */}
      <div className="bg-badge-bg backdrop-blur-md w-full mx-auto max-w-3xl rounded-[30px] mt-6 p-5 sm:p-8 shadow-lg">
        
        {/* Name Row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="First Name"
            {...field("first_name")}
            className="w-full p-3 text-[16px] rounded-[20px]  placeholder:text-placeholder-color bg-[#f7f8f8] border-gray-100 outline-none"
          />
          <input
            type="text"
            placeholder="Last Name"
            {...field("last_name")}
            className="w-full p-3 text-[16px] rounded-[20px]  placeholder:text-placeholder-color bg-[#f7f8f8] border-gray-100 outline-none"
          />
        </div>

        {/* Email */}
        <input
          type="email"
          placeholder="Enter your e-mail"
          {...field("email")}
          className="w-full p-3 text-[16px] rounded-[20px]  placeholder:text-placeholder-color bg-[#f7f8f8] border-gray-100 mt-2 outline-none"
        />

        {/* Message */}
        <textarea
          placeholder="Enter your message"
          {...field("message")}
          className="w-full p-3 text-[16px] rounded-[20px]  placeholder:text-placeholder-color bg-[#f7f8f8] border-gray-100 mt-2 h-32 outline-none"
        ></textarea>

        {/* Button */}
        <button
          type="button"
          onClick={send}
          disabled={sending}
          className="w-full bg-[#F3BC48] text-[#0D0D12] font-semibold py-3 rounded-full mt-2 hover:opacity-90 transition disabled:opacity-60"
        >
          {sending ? "Sending…" : "Send Message"}
        </button>
      </div>

      {/* Contact Info */}
      <div className="grid grid-cols-1 mx-auto sm:grid-cols-3 gap-4 mt-4 sm:mt-6 w-full max-w-3xl mb-10 sm:mb-0 ">
        
        {/* Phone */}
        <div className="bg-badge-bg rounded-[30px] p-6 text-center shadow-md">
          <h4 className="font-semibold text-[16px] text-nuetral-100">Phone</h4>
          <a href={CSF_CONTACT.phoneHref} className="block text-[#3B3B3B] text-[16px] mt-1 hover:underline">{CSF_CONTACT.phone}</a>
        </div>

        {/* Email */}
        <div className="bg-badge-bg rounded-[30px] p-6 text-center shadow-md">
          <h4 className="font-semibold text-[16px] text-nuetral-100">Email</h4>
          <a href={`mailto:${CSF_CONTACT.email}`} className="block text-[#3B3B3B] text-[16px] mt-1 hover:underline break-all">{CSF_CONTACT.email}</a>
        </div>

        {/* Location */}
        <div className="bg-badge-bg rounded-[30px] p-6 text-center shadow-md">
          <h4 className="font-semibold text-[16px] text-nuetral-100">Location</h4>
          <a href={CSF_CONTACT.mapHref} target="_blank" rel="noopener noreferrer" className="block text-[#3B3B3B] text-[16px] mt-1 hover:underline">{CSF_CONTACT.address}</a>
        </div>

      </div>
</main>
<Footer isFixed={false} />
    </div>
  );
}
